var map = {
	"./1B.svg": 88,
	"./1J.svg": 89,
	"./2B.svg": 45,
	"./2Bbase.svg": 90,
	"./2C.svg": 91,
	"./2D.svg": 92,
	"./2H.svg": 93,
	"./2J.svg": 94,
	"./2S.svg": 95,
	"./3C.svg": 96,
	"./3D.svg": 97,
	"./3H.svg": 98,
	"./3S.svg": 99,
	"./4C.svg": 100,
	"./4D.svg": 101,
	"./4H.svg": 102,
	"./4S.svg": 103,
	"./5C.svg": 104,
	"./5D.svg": 105,
	"./5H.svg": 106,
	"./5S.svg": 107,
	"./6C.svg": 108,
	"./6D.svg": 109,
	"./6H.svg": 110,
	"./6S.svg": 111,
	"./7C.svg": 112,
	"./7D.svg": 113,
	"./7H.svg": 114,
	"./7S.svg": 115,
	"./8C.svg": 116,
	"./8D.svg": 117,
	"./8H.svg": 118,
	"./8S.svg": 119,
	"./9C.svg": 120,
	"./9D.svg": 121,
	"./9H.svg": 122,
	"./9S.svg": 123,
	"./AC.svg": 46,
	"./AD.svg": 47,
	"./AH.svg": 48,
	"./AS.svg": 49,
	"./JC.svg": 124,
	"./JD.svg": 125,
	"./JH.svg": 126,
	"./JS.svg": 127,
	"./KC.svg": 128,
	"./KD.svg": 129,
	"./KH.svg": 130,
	"./KS.svg": 131,
	"./QC.svg": 132,
	"./QD.svg": 133,
	"./QH.svg": 134,
	"./QS.svg": 135,
	"./TC.svg": 136,
	"./TD.svg": 137,
	"./TH.svg": 138,
	"./TS.svg": 139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;